<template>
  <modal-notification
    :type="type"
    :close="typeof notification.is_dismissible !== 'undefined' ? notification.is_dismissible : true"
    :is-showing="isShowing"
    :size="size"
    :scrollable="true"
    :title="title"
    :with-header="true"
    :severity="notification.type"
    @close="destroyNotification()"
  >
    <template v-slot:header>
      <h4 class="mt-2" v-show="notification.modal && notification.modal.title">
        {{ notification.modal && notification.modal.title }}
      </h4>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 notification-body">
          <p v-if="notification.image" class="mt-3">
            <a :href="notification.image" target="_blank">
              <img :src="notification.image" class="border p-1 img-fluid w-100" />
            </a>
          </p>
          <p
            v-if="displayHTMLContent(notification?.message).type === 'html'"
            v-html="displayHTMLContent(notification?.message).content"
            class="mt-3 text-justify"
          ></p>
          <template v-else>
            <i18n-t :keypath="notification?.message" tag="p" class="mt-3 text-justify" />
          </template>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <base-checkbox
        :label="'notification-' + notification.id"
        v-model="accepted"
        v-if="notification.is_dismissible === false"
      >
        {{ notification.cta ? notification.cta : $t('components.notification_modal.agree') }}</base-checkbox
      >

      <base-button
        item-class="btn-light my-2"
        @click="destroyNotification()"
        :disabled="notification.dismissible || (notification.is_dismissible === false && !accepted)"
        >{{
          (notification.modal && notification.modal.buttonLabel) ||
          (notification.cta ? notification.cta : $t('components.notification_modal.ok'))
        }}</base-button
      >
    </template>
  </modal-notification>
</template>

<script setup>
import { onMounted, ref } from 'vue'

import store from '@/store/store'

import { eventEmitter } from '@/event-bus'

import { displayHTMLContent } from '@/utilities/helpers.js'

import { NOTIFICATION_SEVERITY_TYPE_CLASSES, NOTIFICATION_SEVERITY_TYPES_MAP } from '@/constants/constants'

import BaseButton from '@/components/BaseButton'
import BaseCheckbox from '@/components/BaseCheckbox'
import ModalNotification from '@/components/ModalNotification'

// #region - prop definitions
const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
})
// endregion

// #region - Refs
const isShowing = ref(false)
const type = ref(null)
const title = ref('')
const size = ref('md')
const accepted = ref(false)
// endregion

// #region - onMounted hook
onMounted(() => {
  type.value = NOTIFICATION_SEVERITY_TYPE_CLASSES[props.notification.type]
  title.value = NOTIFICATION_SEVERITY_TYPES_MAP[props.notification.type]
  isShowing.value = true

  if (props.notification.image) {
    size.value = 'lg'
  }
})
// endregion

// #region - Method definitions
const destroyNotification = () => {
  isShowing.value = false
  store.commit('notificationPermission/UPDATE_SYSTEM_NOTIFICATION_APPROVAL', true)

  setTimeout(() => {
    store.dispatch('notification/remove', props.notification)
    eventEmitter.emit('notificationRead', props.notification)
  }, 1)
}
// endregion
</script>

<style scoped>
:deep(ul) {
  position: relative !important;
  display: inline-block !important;
  padding-left: 1em !important;
}

:deep(.media) {
  display: block !important;
}
</style>
<style>
.notification-body img {
  max-width: 100% !important;
}
</style>
